import { createAction } from 'typesafe-actions';
import { ACTIONS, ChipType } from './types';

export const updateActiveChipAction = createAction(ACTIONS.UPDATE_ACTIVE_CHIP)();

export const setActiveChipAction = createAction(ACTIONS.SET_ACTIVE_CHIP)<{
  chip: ChipType | null;
}>();
